<p-dialog
        [(visible)]="visible"
        [modal]="true"
        [header]="'Update Name and Description'"
        [closable]="true"
        [resizable]="false"
        [draggable]="false"
        [style]="{ width: '600px' }"
        (onHide)="closeDialog()"
>
    <div class="flex flex-col gap-6 my-3">
        <p-input-group>
            <p-ifta-label>
                <input
                        pInputText
                        id="filename"
                        [(ngModel)]="editableFilename"
                        autocomplete="off"
                        class="w-full"
                        placeholder="Enter filename"
                />
                <label for="filename">Filename</label>
            </p-ifta-label>
            <p-inputgroup-addon>
                {{ fileExtension }}
            </p-inputgroup-addon>
        </p-input-group>

        <p-ifta-label>
            <textarea
                    pTextarea
                    id="description"
                    [(ngModel)]="media.description"
                    rows="3"
                    class="w-full"
                    placeholder="Enter description"
            ></textarea>
            <label for="description">Description</label>
        </p-ifta-label>

        <div class="flex justify-end gap-2 mt-10">
            <p-button
                    label="Cancel"
                    icon="pi pi-times"
                    class="p-button-text"
                    (click)="closeDialog()"
                    severity="secondary"
            ></p-button>
            <p-button
                    label="Save"
                    icon="pi pi-check"
                    (click)="save()"
                    [disabled]="!editableFilename"
            ></p-button>
        </div>
    </div>
</p-dialog>
